module.exports = __webpack_public_path__ + "static/img/avatar-icon.660500b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rebate-center/avatar-icon.png
// module id = rS72
// module chunks = 39